export const beeldbellenAnalyticsEvents = [
  'gesprekGestartVanuitBerichten',
  'gesprekGestartVanuitAfspraak',
  'gesprekDeelgenomenVanuitBerichten',
  'gesprekDeelgenomenVanuitAfspraak',
  'gesprekVerlaten',
] as const;
